import { MapperBase } from '../../../utilities/mapper-base';
import { ArchiveJobResource } from '../../resource/archive-job.resource';
import { ArchiveJob } from '../../archive-job.model';
import { FormattingUtility } from '../../../utilities/formatting.utility';

export class ArchiveJobResourceToArchiveJobMapper extends MapperBase<ArchiveJobResource, ArchiveJob> {
    map(source: ArchiveJobResource): ArchiveJob {
        const dest = new ArchiveJob();
        dest.archiveJobId = source.archiveJobId;
        dest.caseId = source.caseId;
        dest.title = source.title;
        dest.comments = source.comments;
        dest.createdById = source.createdById;
        dest.createdBy = source.createdBy.userName;
        dest.dateTimeCreated = source.dateTimeCreated ? new Date(source.dateTimeCreated) : null;
        dest.runById = source.runById;
        dest.runBy = source.runBy?.userName;
        dest.dateTimeRun = source.dateTimeRun ? new Date(source.dateTimeRun) : null;
        dest.archiveBaseNumberStart = source.archiveBaseNumberStart;
        dest.archiveBaseNumberDigits = source.archiveBaseNumberDigits;
        dest.isCreateTiff = source.isCreateTiff;
        dest.lifeCycle = source.lifeCycle;
        dest.status = source.status;
        dest.docSizeArchived = FormattingUtility.bytesAsGB(source.docSizeArchived);
        dest.totalDocCount = source.archiveJobDocCount;
        return dest;
    }
}
